// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/body/frontPage.styl
// module id = 414
// module chunks = 0